import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    tooltipTitle: {
      marginLeft: 10,
      height: 16,
      cursor: 'pointer',
    },
  });
